import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import tw from "twin.macro";
import { Subheading as SubheadingBase } from "../WhoWeAre/Headings.js";
import { SectionDescription } from "../WhatWeDo/Typography.js";
import { Container, ContentWithPaddingXl } from "../WhatWeDo/Layouts.js";
import { ReactComponent as ArrowRightIcon } from "../../Images/arrow-right-icon.svg";
import ProductEngg from "../../Images/Product-engineering.svg";
import ApplicatonSupport from "../../Images/Application-maintenance-&-support.svg";
import Dedicated from "../../Images/Dedicated-development-teams.svg";
import AppDev from "../../Images/Application-development.svg";
import ApiDev from "../../Images/ApiDev.svg";
import ThirdParty from "../../Images/ThirdPartyApi.svg";

const Heading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center md:pt-24` ;
const PdfHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center pt-16`;
const Subheading = tw(SubheadingBase)`text-center mb-3`;
const Description = tw(SectionDescription)`text-center mx-auto`;
const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center  mx-auto -mt-16 my-10`}
`;
const Column = styled.div`
  ${tw`lg:w-1/3 my-2`}
`;
const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 inline-block`;
const Card = styled.a`
  ${tw`flex flex-col items-center text-center h-full mx-5 px-1  transition-transform duration-300 hover:cursor-pointer p-5 hover:shadow-xl hover:p-5 hover:bg-gray-100`}
  .imageContainer {
    ${tw`text-center rounded-full p-4 bg-gray-100 `}
    img {
      ${tw`w-8 h-8 hover:cursor-pointer`}
    }
  }
  .title {
    ${tw`mt-4 text-xl font-medium md:whitespace-nowrap leading-none h-5`}
  }
  .description {
    ${tw`mt-4 text-lg text-gray-700 text-justify `}
  }
  .pdfdescription {
    ${tw`mt-4 text-lg text-gray-700 text-justify `}
  }

  .imageCss {
    ${tw`w-40! h-40!`}
  }
  .imageCss1 {
    ${tw`w-20! h-20!`}
  }

  .imageContainerCss {
    ${tw`p-2!`}
  }

  .link {
    ${tw`mt-auto inline-flex items-center  justify-end w-full text-sm font-bold text-blue-700 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;

const OurServices = (props) => {
  const navigate = useNavigate();
  let services = [
      {
        route: "application-development",
        imageSrc: AppDev,
        title: "Application development",
        description:
          "Our skilled team creates innovative, user-friendly mobile and web solutions using cutting-edge technologies.",
        //url: "https://reddit.com"
      },
      {
        route: "api-development",
        imageSrc: ApiDev,
        title: "API development",
        description:
          "Empower your digital presence with our API Development services, delivering scalable solutions for seamless integration and functionality.",
        //url: "https://reddit.com"
      },
      {
        route: "application-support",
        imageSrc: ApplicatonSupport,
        title: "Application maintenance & support ",
        description:
          "Free up your core teams to build new ones while we take care of maintaining and upgrading your existing or legacy applications.",
        //url: "https://reddit.com"
      },
      {
        route: "third-party-api-integrations",
        imageSrc: ThirdParty,
        title: "Third-Party API Integrations",
        description:
          "Elevate your systems with seamless Third-Party API Integration. Enhance efficiency and extend capabilities effortlessly through our expert integration services.",
        //url: "https://reddit.com"
      },
      {
        route: "dedicated-development-teams",
        imageSrc: Dedicated,
        title: "Dedicated development teams",
        description:
          "Expand your IT capabilities with our dedicated offshore teams.",

        //url: "https://google.com"
      },
      {
        route: "product-engineering",
        imageSrc: ProductEngg,
        title: "Product engineering",
        description:
          "With 25 years of expertise in helping customers build enterprise applications and taking product to market, our principals will help drive your innovation.",
        //url: "https://reddit.com"
      },
    ],
    linkText = "Read More",
    heading = "",
    subheading = "",
    description = "",
    imageContainerCss = null,
    imageCss = null;

  return (
    <>
      <Container
        id={props.id}
        className={props.whatwedo === "pdf" ? "whatWeDoPdf" : ""}
      >
      {  props.whatwedo !== "pdf" ? <Heading>
          Our
          <HighlightedText className="transform -skew-x-12 ml-3">
            Services
          </HighlightedText>
        </Heading> : <PdfHeading>
          Our
          <HighlightedText className="transform -skew-x-12 ml-3">
            Services
          </HighlightedText>
        </PdfHeading>}

        <ContentWithPaddingXl>
          {/* {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>} */}
          <ThreeColumnContainer>
            {services.map((card, i) => (
              <Column key={i}>
                <Card
                  className="transform group hover:scale-110 group/item  hover:bg-slate-100"
                  onClick={() => navigate(`/our-services/${card.route}`)}
                >
                  <span
                    className="imageContainer imageContainerCss"
                    css={imageContainerCss}
                  >
                    <img
                      src={card.imageSrc}
                      alt=""
                      css={imageCss}
                      className={
                        props.whatwedo !== "pdf" ? "imageCss" : "imageCss1"
                      }
                    />
                  </span>
                  <span className="title" style={{ float: "left" }}>
                    {card.title}
                  </span>
                  <p className="description">{card.description}</p>
                  {linkText && (
                    <>
                      <span className="link  group-hover:hidden">
                        <ArrowRightIcon className="icon rotate-45" />
                      </span>
                      <span className="link invisible group-hover:visible">
                        {linkText} <ArrowRightIcon className="icon " />
                      </span>
                    </>
                  )}
                </Card>
              </Column>
            ))}
          </ThreeColumnContainer>
        </ContentWithPaddingXl>
      </Container>
    </>
  );
};

export default OurServices;
